import  {styled} from "@mui/material";

export const Wrapper = styled("div")({
  alignSelf: "flex-end", 
  marginLeft: "20px"
});

export const LegendContentWrapper = styled("div")({
  width: "100%",
  display: "flex",
  alignItems: "flex-start",
  margin: "12px",
  flexDirection: "column",
  "& div:last-of-type": {
    marginBottom: "0px"
  }
});

export const Legend = styled("span", {
  shouldForwardProp: prop => prop !== "legendColor",
})<{legendColor: string}>((prop) => ({
  display: "inline-block", 
  width: "8px", 
  height: "8px", 
  borderRadius: "50%", 
  backgroundColor: prop.legendColor,
  marginRight: "8px"
}));

export const LegendWrapper = styled("div")({
  display: "inline-block",
  marginBottom: "20px"

});


